const nl = {
    deliveryApp: 'LeveringApp',
    name: 'Naam',
    userName: 'Gebruikersnaam',
    lastName: 'Achternaam',
    telephoneNr:'Telefoon nummer',
    finish: 'Af hebben',
    finished: 'Afgewerkt',
    delete: 'Verwijderen',
    bockPickUp: 'Bock pak op',
    bockBarcodeError: 'De lengte van de streepjescode is verkeerd !',
    bockCode: 'Bock-code',
    bock: 'Bock',
    street: 'Straat',
    zipCodePlace: 'Postcode / plaats',
    number: 'Nummer',
    bockNumber: 'Bock-nummer',
    deliveryDate: 'Bezorgdatum',
    deliveryTime: 'Aflevertijd',
    delivery: 'Levering',
    scannedItems: 'Gescande items',
    bockDelete: 'Bock verwijderen',
    bockDeleteMessage: 'Weet je zeker dat ?',
    yes: 'Ja',
    no: 'Nee',
    orderFinish: 'Bestelling afronden',
    orderNumber: 'Ordernummer',
    bockList: 'Bock lijst',
    emptyList: 'Lijst is leeg',
    onTheTruck: 'Op de vrachtwagen',
    atTheCustomer: 'Bij de klant',
    loadingPlace: 'Laadplaats',
    loadingStatus: 'Laadstatus',  
    position: 'Positie',  
    positions: 'Posities',
    positionNotFound: 'Geen posities gevonden voor deze bestelling',
    commission: 'Commissie',
    settings: 'Instellingen',
    settingsMessage: 'Info: u hebt een internetverbinding nodig om de instellingen op te halen.',
    customer: 'Klant',
    customerSpecifics: 'Klantspecificaties',
    driverNotes: 'Driver notities',
    warehouseAddress: 'Adres magazijn',
    assemblers: 'Assembleurs',
    noAssemblers: 'Assembleurs niet gevonden',
    sync: 'Synchroniseren',
    syncProgress: 'Synchronisatie wordt uitgevoerd',
    backup: 'Back-up',
    sign: 'Teken',    
    customerSignature: 'Handtekening van de klant',
    driverSignature: 'Handtekening bestuurder',
    signDocument: 'Onderteken document',
    signedDocument: 'Document ondertekend',
    saveDocument: 'Document opslaan',
    saveDocumentForAll: `Bewaar documenten voor alle bestellingen van vandaag van dit bedrijf`,
    piece: 'Stuk',
    width: 'Breedte',
    height: 'Hoogte',
    comment: 'Commentaar',
    partially: 'Gedeeltelijk',
    synchronize: 'Synchroniseren',
    dbLoading:'Database laden',
    stop: 'Hou op',
    deletePhoto: 'Verwijder foto ?',
    cancel: 'annuleren',
    confirm: 'Bevestigen',
    confirmAuftragMessage0: `Alle posities worden gecontroleerd, maar de orderstatus is 'Gedeeltelijk', weet u zeker dat u wilt doorgaan?`,
    confirmAuftragMessage1: `Niet alle posities zijn aangevinkt, maar de bestelstatus is 'Gereed', weet u zeker dat u wilt doorgaan?`,
    confirmAuftragMessage2: 'Weet je zeker dat je door wilt gaan ?',
    confirmSelected: 'Bevestig geselecteerde posities ?',
    company: 'Bedrijf',
    none:'Geen',
    save: 'Sparen',
    takePhoto: 'Maak een foto',
    syncFailMessage: 'Synchronisatie mislukt! Probeer het later alstublieft!',
    driverList: 'List of drivers',
    punkt1: 'Levering van goederen op tijd (binnen 30 minuten?)',
    punkt2: 'Goederenlevering compleet?',
    punkt3: 'Goederenlevering zichtbaar beschadigd?',
    EkName: "klantnaam",
    start: "Start",
    end: "Einde",
    clientNotAtHome: "Klant niet ter plaatse",
    mehrTagesTour: "Meerdaagse tour",
    tagesTour:"Dagelijkse tour",
    signatureEmpty:"Beide handtekeningen moeten aanwezig zijn of klant niet ter plaatse moet geselecteerd zijn",
    cusromerAdress: "Klant adres",
    deliveryAdress: "Bezorgadres"
  };
  
  export default nl;